import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import IndexPage from 'flarum/forum/components/IndexPage';
import LinkButton from 'flarum/common/components/LinkButton';
import CookieConsentRoot, { openSettings } from './components/CookieConsentRoot';
import { applyScripts, loadConsent, config, accepted, decideAll, onChange, on, getConsent, READY_EVENT } from '../common/consent';
const t = (k, p) => app.translator.trans('ernestdefoe-acc.forum.' + k, p);
app.initializers.add('ernestdefoe/advanced-cookie-consent', () => {
  // Public API for themes / other extensions to gate their own scripts and to
  // re-open the settings dialog from a custom trigger.
  window.cookieConsent = {
    open: openSettings,
    accepted,
    acceptAll: () => decideAll(true),
    rejectAll: () => decideAll(false),
    config,
    onChange,
    on,
    get: getConsent,
    consent: () => loadConsent()
  };

  // Config reads app.forum.attribute(), which core only sets AFTER the
  // initializers have run (Application.boot: initialize() → pushPayload →
  // this.forum = …). beforeMount callbacks run right after that, before the
  // page mounts. Core doesn't guard them, so a throw here is caught locally
  // rather than taking the whole forum down with it.
  app.beforeMount(() => {
    try {
      boot();
    } catch (e) {
      console.error('[advanced-cookie-consent]', e);
    }
  });
  function boot() {
    if (!config().enabled) return;

    // Run any already-granted gated scripts as early as possible.
    const existing = loadConsent();
    if (existing) applyScripts(existing);

    // Announce the state on every page load, so site code can act on a decision
    // made earlier (e.g. clear cookies of a category that stays rejected).
    window.dispatchEvent(new CustomEvent(READY_EVENT, {
      detail: {
        categories: getConsent()
      }
    }));

    // Mount the banner/dialog on its own node, outside Flarum's #app container,
    // so it overlays everything and works for guests. Flarum Component classes
    // must be created via m(Component), so mount a trivial root that renders it.
    if (document.getElementById('acc-root')) return;
    const node = document.createElement('div');
    node.id = 'acc-root';
    document.body.appendChild(node);
    m.mount(node, {
      view: () => m(CookieConsentRoot)
    });
  }

  // A "Cookie settings" link so visitors can change their mind. Themes can add
  // their own trigger anywhere via window.cookieConsent.open().
  extend(IndexSidebar.prototype, 'items', function (items) {
    // 🚨 The discussion list only. Flarum 2 reuses IndexSidebar for other
    // pages (Messages subclasses it), which lay the list out as a row, and a
    // box dropped in there pushes the whole page out of shape.
    if (!app.current || !app.current.matches(IndexPage)) return;
    items.add('cookieConsent', LinkButton.component({
      icon: 'fas fa-cookie-bite',
      onclick: e => {
        e.preventDefault();
        openSettings();
      },
      href: '#'
    }, t('reopen')), -100);
  });
});